import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'responsiveLabel' })
export class ResponsiveLabelPipe implements PipeTransform {
  transform(isHandset: boolean, label: string, fallback: string = ''): string {
    return isHandset ? fallback : label;
  }
}
